// Legacy, but flyers (mostly QR codes) still carry it: smsto:NUMBER:MESSAGE
const smstoRegex = /^smsto:\+?[0-9]+(?::.*)?$/

// RFC 5724: sms:RECIPIENT[,RECIPIENT]*[?body=MESSAGE]. A recipient is a phone
// number with optional visual separators (RFC 3966); short codes are allowed.
const smsRecipient = String.raw`\+?[0-9().-]*[0-9][0-9().-]*`
const smsField = String.raw`[a-z0-9-]+=[^&\s]*`
const smsRegex = new RegExp(
  `^sms:${smsRecipient}(?:,${smsRecipient})*(?:\\?${smsField}(?:&${smsField})*)?$`
)

export function validateSMSUrlFormat(url: string): boolean {
  const lowered = url.toLowerCase()
  return smstoRegex.test(lowered) || smsRegex.test(lowered)
}

/** smsto:NUMBER:MESSAGE -> sms:NUMBER?body=MESSAGE; anything else as is. */
export function toSmsUri(value: string): string {
  const match = /^smsto:([^:]*)(?::(.*))?$/i.exec(value)
  if (!match) return value
  const [, number, body] = match
  return body ? `sms:${number}?body=${encodeURIComponent(body)}` : `sms:${number}`
}
